import $ from 'jquery';
import BaseEvent from './base-event';

export default class MainMenuEvents extends BaseEvent {
    constructor() {
        super({
            event_id: '15',
            category: 'menu',
            action: 'click',
            label: null,
        });

        this.$menuCont = $('.mc-header__primary-container');

        this.init();
    }

    init() {
        this.onMainTopLevelEvent();
        this.onMainSecondLevelEvent();
        this.onSecondMenuClick();
        this.onMainMobileMenu();
        this.onSecondaryMenuEvent();
        this.onLogoClickEvent();
    }

    onMainTopLevelEvent() {
        this.$menuCont.find('nav.mc-header__primary-nav').find('.mc-header-primary-nav__item > a').on('click', (e) => {
            this.fireEvent({
                action: this.toNormalizedString(e.currentTarget.innerText),
                destination_url: e.currentTarget.href,
            });
        });
    }

    onMainSecondLevelEvent() {
        this.$menuCont.find('nav.mc-header__primary-nav').on('click', '.mc-header-fly-out__sub-item > a', (e) => {
            const actionCont = $(e.target).parents('.mc-header-fly-out').get(0);
            const action = $(actionCont).find('>a').get(0).innerText;

            this.fireEvent({
                action: this.toNormalizedString(action),
                label: this.toNormalizedString(e.currentTarget.innerText),
                destination_url: e.currentTarget.href,
            });
        });
    }

    onSecondMenuClick() {
        $('.mc-header-sub-nav__link').on('click', (e) => {
            const action = $('.mc-header-primary-nav')
                .find('.mc-header-primary-nav__link--underline, .mc-header-primary-nav__item--is-selected a')
                .get(0)?.innerText || null;
            this.fireEvent({
                destination_url: e.currentTarget.href,
                action: action ? this.toNormalizedString(action) : null,
                label: this.toNormalizedString(e.currentTarget.innerText),
            });
        });
    }

    onSecondaryMenuEvent() {
        this.$menuCont.find('.mc-header-secondary-nav').on('click', 'a', (e) => {
            if (!e.currentTarget.href) return;

            let action = e.currentTarget.innerText;
            if (!action) {
                if ($(e.currentTarget).hasClass('mc-header-my-account__link')) {
                    action = 'My Account';
                }
            }

            this.fireEvent({
                action: this.toNormalizedString(action),
                destination_url: e.currentTarget.href,
            });
        });
    }

    onMainMobileMenu() {
        $('.mc-mobile-menu__nav').find('a').on('click', (e) => {
            this.fireEvent({
                action: this.toNormalizedString(e.currentTarget.innerText),
                destination_url: e.currentTarget.href,
            });
        });
    }

    onLogoClickEvent() {
        this.$menuCont.find('.mc-header__logo').on('click', (e) => {
            this.fireEvent({
                action: 'homepage',
                destination_url: e.currentTarget.href,
            });
        });
    }
}
